import styled, { css } from 'styled-components';
import mq from '../../utils/mediaQueries.js';

// @ts-nocheck
var Breadcrumbs = styled.ol.withConfig({
  displayName: "style__Breadcrumbs",
  componentId: "sc-zszq53-0"
})(["color:var(--color-grey-800);font:var(--font-body-s);"]);
var Breadcrumb = styled.li.withConfig({
  displayName: "style__Breadcrumb",
  componentId: "sc-zszq53-1"
})(["display:inline-flex;align-items:center;", " &:last-of-type{pointer-events:none;a{color:var(--color-text-subtle);}.uikit-breadcrumbs__arrow-icon{display:none;}}&:not(:last-of-type){cursor:pointer;}.uikit-breadcrumbs__arrow-icon{color:var(--color-almostblack);cursor:default;display:inline-block;margin:0 var(--space-100);height:10px;width:10px;}"], mq.mMax(css(["", ""], function (props) {
  return props.$desktopOnly && css(["display:none;"]);
})));
var Link = styled.a.withConfig({
  displayName: "style__Link",
  componentId: "sc-zszq53-2"
})(["border-bottom:1px solid transparent;color:var(--color-text);transition:border-color var(--transition),color var(--transition);.no-touch &:hover{", "}"], mq.m(css(["border-color:var(--color-grey-800);cursor:pointer;"])));

export { Breadcrumb, Breadcrumbs, Link };
//# sourceMappingURL=style.js.map
